export const CURRENCY_SYMBOL_FLOAT = {
  LEFT: 'Left',
  RIGHT: 'Right',
};
